/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIFeedbackFormFieldRequest } from './APIFeedbackFormFieldRequest';
import {
    APIFeedbackFormFieldRequestFromJSON,
    APIFeedbackFormFieldRequestFromJSONTyped,
    APIFeedbackFormFieldRequestToJSON,
} from './APIFeedbackFormFieldRequest';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIFeedbackFormRequest
 */
export interface APIFeedbackFormRequest {
    /**
     * 
     * @type {Array<APIFeedbackFormFieldRequest>}
     * @memberof APIFeedbackFormRequest
     */
    formJson: Array<APIFeedbackFormFieldRequest>;
    /**
     * 
     * @type {string}
     * @memberof APIFeedbackFormRequest
     */
    formTitle: string;
}

/**
 * Check if a given object implements the APIFeedbackFormRequest interface.
 */
export function instanceOfAPIFeedbackFormRequest(value: object): value is APIFeedbackFormRequest {
    if (!('formJson' in value) || value['formJson'] === undefined) return false;
    if (!('formTitle' in value) || value['formTitle'] === undefined) return false;
    return true;
}

export function APIFeedbackFormRequestFromJSON(json: any): APIFeedbackFormRequest {
    return APIFeedbackFormRequestFromJSONTyped(json, false);
}

export function APIFeedbackFormRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIFeedbackFormRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'formJson': ((json['form_json'] as Array<any>).map(APIFeedbackFormFieldRequestFromJSON)),
        'formTitle': json['form_title'],
    };
}

export function APIFeedbackFormRequestToJSON(value?: APIFeedbackFormRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'form_json': ((value['formJson'] as Array<any>).map(APIFeedbackFormFieldRequestToJSON)),
        'form_title': value['formTitle'],
    };
}

